import tacHelpers from '../tacHelpers';

/**
 * Selects current tac
 * @param state
 * @returns {(function(*=): boolean)|{settings: {disableMountingRails: boolean}}|{items: [], wall: {points: *}}|State|(function(*=): boolean)}
 */
export const selectPresentTac = state => state.tac.present;

/**
 * Returns true if tac scene is empty
 * @param state
 * @returns {boolean}
 */
export const selectTacIsEmpty = state => {
  const tac = selectPresentTac(state);
  return !tac?.items.some(item => tacHelpers.hasRealArticle(item));
};
